<template>
  <div id="box6">
    <div class="box">
      <div class="videobox">
        <img class="jiaobiao" src="../assets/jiao.png" alt="" />
        <div class="video">
          <img
            ref="fengmian"
            @click="Open"
            src="../assets/fengmian.png"
            alt=""
          />
          <video
            ref="video"
            controls="controls"
            src="https://file.boxuegu.com/video/activity/bigDataExperience.mp4"
            webkit-playsinline
            playsinline
          ></video>
        </div>
      </div>
      <div class="box2-two">
        <div class="box2-two-title">《揭秘千亿成交额下的实时数据处理架构》</div>
        <div class="box2-two-txt" style="margin-top: 0.36rem">Flume采集多数据源处理</div>
        <div class="box2-two-txt">Kafka亿级消息队列处理</div>
        <div class="box2-two-txt">Doris实时OLAP分析</div>
        <div class="box2-two-txt">FineBl实时报表数据展示</div>
        <div class="box2-two-txt">大数据全链路技术栈一网打尽</div>
      </div>
      <div class="one">数据为王的时代来了</div>
      <div class="two">谁掌握了数据，谁就掌握了未来！</div>
      <div class="btn" @click="OpenData($event)">0.9元抢课程</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    OpenData(e) {
      this.$store.commit("Openbigdata");
      this.$mai(2, e);
    },
    Open() {
      this.$refs.fengmian.style.display = "none";
      this.$refs.video.play();
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
  overflow: hidden;
  margin: 0 auto;
  width: 690px;
  height: 1076px;
  background-color: #6b00d9;
  margin-bottom: 80px;
  .one {
    font-family: SourceHanSansCN-Medium;
    font-size: 30px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 3px;
    color: #ffffff;
    text-align: center;
    margin-top: 40px;
  }
  .two {
    @extend .one;
    margin-top: 15px;
  }
  .btn {
    width: 560px;
    height: 88px;
    margin: 0 auto;
    margin-top: 29px;
    background-image: url("../assets/btn.png");
    background-size: 100% 100%;
    font-family: SourceHanSansCN-Bold;
    font-size: 36px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 88px;
    letter-spacing: 2px;
    color: #5530fd;
    text-align: center;
  }
  .box2-two {
    overflow: hidden;
    margin: 0 auto;
    width: 650px;
    height: 358px;
    background-color: #ffffff;
    border-radius: 0 0 10px 10px;
    &-title {
      text-align: center;
      margin-top: 31px;
      font-family: SourceHanSansCN-Bold;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 3px;
      color: #f94b4d;
    }
    &-txt {
      width: 551px;
      margin-top: 10px;
      font-family: SourceHanSansCN-Normal;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 2px;
      color: #2d2664;
      &::before {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        background-color: #ff2b2b;
        margin-left: 28px;
        margin-right: 20px;
        position: relative;
        top: -5px;
      }
    }
  }
  .videobox {
    position: relative;
    margin: 0 auto;
    margin-top: 30px;
    width: 650px;
    height: 403px;
    border-radius: 10px 10px 0 0;
    background-color: #9f7fff;
    .jiaobiao {
      z-index: 1;
      display: block;
      width: 119px;
      height: 119px;
      position: absolute;
      top: -7px;
      right: -7px;
    }
  }
  .video {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 576px;
    height: 325px;
    border: 10px solid #7a58ff;
    img {
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 100%;
      height: 100%;
    }
    video {
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      width: 100%;
      height: 100%;
    }
  }
}
</style>